const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
  dataIndex: 0,
    id: '2pool',
    name: '2pool',
    lpTokenInfo: {
        name: '2poolCurve',
        symbol: '2poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        lpToken: '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        gauge: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',  //fake gauge
    },
    gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
    additionalRewards: [{
        key: 'CRV2POOL',
        name: 'CRV',
        amountDataKey: 'crvRewards',
        rewardTokenAddress: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
        rewardTokenDecimals: 18,
        rewardContract: '0xFf17560d746F85674FE7629cE986E949602EF948',
        rewardTokenCoingeckoId: 'curve-dao-token',
    }],
  },
  {
      dataIndex: 1,
      id: 'tricrypto',
      name: 'tricrypto',
      lpTokenInfo: {
          name: '3CrvCrypto',
          symbol: '3CrvCrypto',
      },
      assets: 'usdt+weth+wbtc',
      coins: [
          coins.usdt,
          coins.wbtc,
          coins.weth,
      ],
      allowTradingEth: true,
      addresses: {
          swap: '0x960ea3e3C7FB317332d990873d354E18d7645590',
          lpToken: '0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2',
          deposit: '0xF97c707024ef0DD3E77a0824555a46B622bfB500',
          gauge: '0x97E2768e8E73511cA874545DC5Ff8067eB19B787',
      },
      gaugeVersion: 3, // No CRV rewards
      hasNoCRVRewards: true,
      cryptoPool: true,
      referenceAsset: REFERENCE_ASSETS.CRYPTO,
      additionalRewards: [{
          key: 'CRVTRI',
          name: 'CRV',
          amountDataKey: 'crvRewards',
          rewardTokenAddress: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
          rewardTokenDecimals: 18,
          rewardContract: '0x9044E12fB1732f88ed0c93cfa5E9bB9bD2990cE5',
          rewardTokenCoingeckoId: 'curve-dao-token',
      }],
    }, {

        dataIndex: 2,
        id: 'ren',
        name: 'ren',
        lpTokenInfo: {
            name: 'renCurve',
            symbol: 'renCrv',
        },
        coingeckoInfo: {
            id: 'renbtc',
            symbol: 'RENBTC',
            referenceAssetId: 'bitcoin',
        },
        assets: 'wBTC+renBTC',
        coins: [
            coins.wbtc,
            coins.renbtc,
        ],
        addresses: {
            swap: '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb',
            lpToken: '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb',
            gauge: '0xC2b1DF84112619D190193E48148000e3990Bf627',
        },
        gaugeVersion: 3, // No CRV rewards
        referenceAsset: REFERENCE_ASSETS.BTC,
        hasNoCRVRewards: true,
        additionalRewards: [{
            key: 'CRVREN',
            name: 'CRV',
            amountDataKey: 'crvRewards',
            rewardTokenAddress: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
            rewardTokenDecimals: 18,
            rewardContract: '0x9F86c5142369B1Ffd4223E5A2F2005FC66807894',
            rewardTokenCoingeckoId: 'curve-dao-token',
        }],
      },
      {
          dataIndex: 6,
          id: 'eursusd',
          name: 'eursusd',
          referenceAsset: REFERENCE_ASSETS.CRYPTO,
          isForexMetaPool: true,
          lpTokenInfo: {
              name: 'eurUsdCurve',
              symbol: 'eurUsdCrv',
          },
          coingeckoInfo: {
              id: 'stasis-eurs',
              symbol: 'EURs',
          },
          isMetaPool: true,
          cryptoPool: true,
          // isFakePlainPool: true,
          assets: 'EURs+a3pool',
          coins: [
              coins.eurs,
              coins['2pool']
          ],
          metaCoins: [
              coins.usdc,
              coins.usdt,
          ],
          addresses: {
              swap: '0xA827a652Ead76c6B0b3D19dba05452E06e25c27e',
              lpToken: '0x3dFe1324A0ee9d86337d06aEB829dEb4528DB9CA',
              gauge: '0x37C7ef6B0E23C9bd9B620A6daBbFEC13CE30D824',
              deposit: '0x25e2e8d104BC1A70492e2BE32dA7c1f8367F9d2c',
          },
          additionalRewards: [{
              key: 'CRVEURS',
              name: 'CRV',
              amountDataKey: 'crvRewards',
              rewardTokenAddress: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
              rewardTokenDecimals: 18,
              rewardContract: '0x56eda719d82aE45cBB87B7030D3FB485685Bea45',
              rewardTokenCoingeckoId: 'curve-dao-token',
          }],
          gaugeVersion: 3, // No CRV rewards
          hasNoCRVRewards: true
      },
      {
          dataIndex: 2,
          id: 'wsteth',
          name: 'wstETH',
          lpTokenInfo: {
              name: 'wstETHCurve',
              symbol: 'wstETHCrv',
          },
          coingeckoInfo: {
              id: 'wsteth',
              symbol: 'wstETH',
              referenceAssetId: 'wrapped-steth',
          },
          assets: 'ETH+wstETH',
          coins: [
              coins.eth,
              coins.wsteth,
          ],
          addresses: {
              swap: '0x6eB2dc694eB516B16Dc9FBc678C60052BbdD7d80',
              lpToken: '0xDbcD16e622c95AcB2650b38eC799f76BFC557a0b',
              gauge: '0x098EF55011B6B8c99845128114A9D9159777d697',
          },
          gaugeVersion: 3, // No CRV rewards
          referenceAsset: REFERENCE_ASSETS.ETH,
          hasNoCRVRewards: true,
        },
];
